import React from 'react'
import { useTranslation } from 'react-i18next'
import { useInstantSearch, Hits } from 'react-instantsearch'

import { useSearchContext } from '@components/context/SearchContext'

import CourseHit from './CourseHit'
import { AlgoliaCourseHit } from './Search'

export default function CourseHitList() {
  const { results, status } = useInstantSearch()
  const { searchText } = useSearchContext()
  const { t } = useTranslation('revamp')

  const isLoading = status === 'loading' || status === 'stalled'

  const hasQuery = searchText.length > 0
  const hasNoResults = results?.nbHits === 0 && !results?.__isArtificial && !isLoading

  if (hasQuery && hasNoResults) {
    return (
      <p className='mt-2 text-base'>
        {t('noResultsFor')} <q>{searchText}</q>.
      </p>
    )
  }

  return (
    <Hits<AlgoliaCourseHit>
      className='flex-grow w-full mt-2 hits-divider overflow-hidden'
      hitComponent={CourseHit}
      classNames={{ list: 'hits-list' }}
    />
  )
}
